import {z} from 'zod';

export const SyncStatusSchema = z.enum(['draft', 'started', 'paused']);
export type SyncStatus = z.infer<typeof SyncStatusSchema>;
